
module.exports = {


//database:'http://localhost:4000/'
   
database:'https://backpipo.ciudaddecorrientes.gov.ar/'
   
   
   }

